var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.5 27C38.0147 27 36 24.9853 36 22.5C36 20.0147 38.0147 18 40.5 18C42.9853 18 45 20.0147 45 22.5C44.9973 24.9841 42.9841 26.9973 40.5 27Z",
    fill: "#D5E2FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57 6H15C10.0354 6.01449 6.01449 10.0354 6 15V41.58L17.64 29.94C21.2024 26.55 26.7976 26.55 30.36 29.94L38.9742 38.601L41.6367 35.9385C45.1571 32.4386 50.8429 32.4386 54.3633 35.9385L66 47.5752V15C65.9855 10.0354 61.9646 6.01449 57 6ZM40.5 27C38.0147 27 36 24.9853 36 22.5C36 20.0147 38.0147 18 40.5 18C42.9853 18 45 20.0147 45 22.5C44.9973 24.9841 42.9841 26.9973 40.5 27Z",
    fill: "#88ACFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.36 29.94C26.7976 26.55 21.2024 26.55 17.64 29.94L6 41.58V57C6.01452 61.9645 10.0355 65.9854 15 66H57C59.4454 65.9989 61.7849 65.0025 63.48 63.24L30.36 29.94Z",
    fill: "#174CC4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M66.0004 47.5753L54.3637 35.9386C50.8434 32.4388 45.1575 32.4388 41.6372 35.9386L38.9746 38.6011L63.4674 63.2268C65.0937 61.5625 66.0031 59.3271 66.0004 57.0001V47.5753Z",
    fill: "#D5E2FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.c4e3777d73e6546519067184864ac4b8.svg";
export { ForwardRef as ReactComponent };